import { Component, Input } from '@angular/core';
import { BreadcrumbLevel } from '@common/models/breadcrumbLevel.model';

@Component({
  selector: 'app-breadcrumb-component',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss'],
})
export class BreadcrumbComponent {
  @Input() levels: BreadcrumbLevel[];
  @Input() name: string;
  @Input() topLevelName: string;

  generateLink(index: number): string {
    let link = '/' + this.topLevelName + '/';

    for (let i = 0; i <= index; i += 1) {
      const level = this.levels[i];

      Object.keys(level).forEach((key) => {
        if (key.indexOf('Key') !== -1) {
          link += level[key] + '/';
        }
      });
    }

    return link;
  }

  generateName(index: number): string {
    const level: BreadcrumbLevel = this.levels[index];
    let name: string;

    Object.keys(level).forEach((key) => {
      if (key.indexOf('Name') !== -1) {
        name = level[key];
      }
    });

    return name;
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/BreadcrumbComponent/breadcrumb.component.ts